import {createContext} from "react";
import type {usePushNotifications} from "@/hooks/usePushNotifications";

export type PushNotifications = ReturnType<typeof usePushNotifications>;

/**
 * The provider lives in `AppLayout` and wraps every consumer, so the null
 * default is never observed at runtime. Typing it as non-null keeps consumers
 * assertion-free, which is what the previous `createContext<any>` did.
 */
export const PushNotificationsContext = createContext<PushNotifications>(
  null as unknown as PushNotifications,
);
